export interface RebateGroupsSummaryDto {
  groupsCount: number
  tasInGroups: number
  tasWithManualApproval: number
  tasNotInGroup: number
}

export enum RebateApprovalType {
  Manual = 1,
  Auto = 2,
}

export enum RebateApprovalPeriod {
  Instant = 0,
  Weekly = 1,
  Every2Weeks = 2,
  Monthly = 3,
}
